import lodash from 'lodash';

import type { Node, PluginContainerData } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { getContainerData } from './../../../../../_shared/node-styles.js';

import styles from './plugin-scss.js';

export const getAlignmentClassName = (containerData?: PluginContainerData | null) => {
  const alignment = containerData?.alignment;

  if (!alignment) {
    return '';
  }

  const key = `align${lodash.upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};

export const getSizeClassName = (containerData?: PluginContainerData | null) => {
  const size = containerData?.width?.size;

  if (!size || size === 'FULL_WIDTH') {
    return '';
  }

  const key = `size${lodash.upperFirst(size.toLowerCase())}`;
  return styles[key];
};

export const getTextWrapClassName = (containerData?: PluginContainerData | null): string => {
  if (containerData?.textWrap) {
    return '';
  }

  return styles.textWrapNowrap;
};

export const alignmentClassName = (node: Node): string => {
  return getAlignmentClassName(getContainerData(node));
};

export const sizeClassName = (node: Node): string => {
  return getSizeClassName(getContainerData(node));
};

export const textWrapClassName = (node: Node): string => {
  return getTextWrapClassName(getContainerData(node));
};
